import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/selling/LeftMenu';
import ContactUs from '../components/ContactUs';
import SellYourMachineIn30Days from '../components/SellYourMachineIn30Days';

const PaymentProcess = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('selling'),
      url: '/content/selling/auction-process',
    },
    {
      label: 'Ödeme Süreci',
      url: '/content/selling/payment-process',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="payment-process" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Ödeme Süreci</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  iyiMakina.com, alıcı ve satıcı arasındaki maddi ve hukuki işleri üstlenmektedir.
                  Satıcılar güvenle ödemesini teslim alırken, alıcılar sorunsuz ve güvenceyle ödeme işlemini gerçekleştirirler.
                </p>
                <p>
                  Ödeme ve devir işlemlerinin tamamı iyiMakina Bilgi Teknolojileri A.Ş. üzerinden kurumsal bir yaklaşımla gerçekleşmektedir.
                  45 yıllık tecrübemizle, her aşamada alıcı ve satıcıların yanındayız.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Aynı Günde Devir İşlemi</h2>
              </div>
              <div className="col-15">
                <p>
                  İnternet sitemiz üzerinden sattığınız makinaların devrini güvenle yapalım. Üstelik 1 iş günü içinde işlemleri bitirelim.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Satıcılar için Platform Kullanım Ücreti</h2>
              </div>
              <div className="col-15">
                <p>
                  Satılan makinalardan platform kullanım ücreti olarak, satıcı kurum veya kişiyle iyiMakina arasında önceden belirlenmiş oranda ve satışın gerçekleştiği koşullarda alıcıdan yapılan tahsilat içerisinden mahsup edilir.
                </p>
                <p>
                  Platform kullanım ücreti; iyiMakina Bilgi Teknolojileri ve Ticaret A.Ş'nin Teknokent içerisinde yer almasından dolayı 4196 sayılı kanun uyarınca KDV'den muaf tutulmaktadır.
                  Bu sebeple platform kullanım ücreti özelinde herhangi bir artı KDV maliyetine katlanmanız gerekmez.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Havuz Hesap ile Sorunsuz Tahsilat</h2>
              </div>
              <div className="col-15">
                <p>
                  Ödemesi yapılan makinanın ödemesi, iyiMakina.com’un havuz hesabında askıda bekler, makinayı teslim ettiğiniz an ödeme aktarılır.
                </p>
              </div>
            </div>
            <SellYourMachineIn30Days />
            <ContactUs about="Ödeme Süreciyle" />
          </div>
        </div>
      </div>
    </main>
  );
};

PaymentProcess.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Ödeme Süreci',
    },
  };
};

PaymentProcess.Layout = Layout;

export default withTranslation('common')(PaymentProcess);
